import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CollateralSkillSet } from '../collateralskillset.model';
import { CollateralskillsetEditComponent } from '../collateralskillset-edit/collateralskillset-edit.component';
import { CollateralskillsetsService } from '../collateralskillsets.service';

@Component({
  selector: 'app-skillsets',
  templateUrl: './skillsets.component.html',
  styleUrls: ['./skillsets.component.css']
})
export class SkillsetsComponent implements OnInit {
    @Input() public skillset: CollateralSkillSet;
    constructor(private collateralSkillsetservice: CollateralskillsetsService,public dialog: MatDialog) { }

  ngOnInit() {
  }

    private editSkillSet(event) {
        this.dialog.open(CollateralskillsetEditComponent, {
            data: this.skillset
        });
    }

    private deleteSkillSet(skillset: CollateralSkillSet) {
        if (confirm('Are you sure you want to delete ' + skillset.name + '?')) {
            this.collateralSkillsetservice.deleteSkillset(skillset.id)
                .then(success => {
                    if (!success)
                        confirm('There was an error processing your request.');
                })
                .catch(error => {
                    confirm('There was an error processing your request.');
                });
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/skillsets/skillsets.component.ts